import dayjs from "dayjs";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import { Col, Button, Row, Space, Tabs, Card, Modal, Badge } from "antd";
import { DatePicker, Input, TimePicker } from "components/form";

import schema, {
  initialValues as INITIAL_VALUES,
} from "../schemas/endorseTimeSchema";
import { ConfigProvider, Flex } from "antd/lib";
import { MY_REQUEST_TYPE } from "../schemas/myRequestSchema";
import { useCallback, useEffect, useState } from "react";
import StatusTag from "components/elements/TagCustom/StatusTag";
import styles from "./Input.module.css";
import i18n from "i18n";
import Dragger from "antd/lib/upload/Dragger";
import { CloudUploadOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import * as services from "../services/myDocumentApi";
import { dataURLtoFile, generateRandomString } from "utils/helper";
import WorkinStatus from "components/elements/TagCustom/WorkinStatus";
import { REQUEST_APPROVE_TAB } from "features/requestApproval/schemas/RequestApproveTab";
import * as Yup from "yup";

function formatDate(dateString, pattern = "YYYY-MM-DD") {
  if (!dateString) return;
  const date = dayjs(dateString, pattern);
  return date.format("DD-MM-YYYY");
}

function formatDateTime(dateString) {
  if (!dateString) return;
  const date = dayjs(dateString);
  return date.format(i18n.language === "en" ? "DD/MM/YYYY HH:mm" : `DD/MM/${date.year() + 543} HH:mm`);
}

function EndorseTimeForm({
  className = "",
  modalType = "",
  initialValues = {},
  onDraft = () => { },
  onCancel = () => { },
  onSubmit = () => { },
  onDeleteFile = () => { },
  onAttachFileChange = () => { },
  standAlone = true,
  approveType = "",
  onApprove = () => { },
  onReject = () => { },
  onDelete = () => { },

}) {
  const { t, i18n } = useTranslation();
  const [selectedMenu, setMenu] = useState(MY_REQUEST_TYPE.DETAIL);
  const [useCurrentMenu, setCurrentMenu] = useState(MY_REQUEST_TYPE.DETAIL);
  const [fileName, seeFileName] = useState([]);
  const [imageUrl, setImageUrl] = useState([]);
  const [fileSizeInMB, setfileSizeInMB] = useState([])
  const [fileType, setFileType] = useState([]);
  const [initialValuesFileName, setInitialValuesFileName] = useState([]);
  const [initialValuesImageUrl, setInitialValuesImageUrl] = useState([]);
  const [initialValuesFileType, setInitialValuesFileType] = useState([]);
  const [initialValuesFileList, setInitialValuesFileList] = useState([]);

  const currentCompany = useSelector((state) => state.company.currentCompany);
  const currentEmployee = useSelector((state) => state.company.currentEmployee);
  const [currentWorkflow, setCurrentWorkflow] = useState([]);
  const [listEmployees, setListEmployees] = useState({});
  const [openListEmployee, setOpenListEmployee] = useState(false);

  function fnRejectFor(initialValues) {
    let language = i18n.language === 'en' ? "En" : ""

    let condition = initialValues?.rejectWorkflow?.length > 0 ? 1 : 2
    let data = {}
    if (condition == 1) {
      data = initialValues?.rejectWorkflow.map((o, index) => {
        let rejectFlow = initialValues.timelineReject.filter(o => o.approveStatusEn != 'Pending')
        return {
          ...o,
          date: rejectFlow?.[index]?.date ?? null,
          approveStatusEn: rejectFlow?.[index]?.approveStatusEn ?? "Pending",
          approveStatus: rejectFlow?.[index]?.approveStatus ?? "รออนุมัติคำขอ"
        }
      })
    } else {
      data = initialValues.timelineReject
    }


    const hasRejectedStatus = initialValues.timelineReject?.some(item =>
      (item.approveStatusEn === "Rejected"));

    return data?.map((workflow, index) => {
      const isPending = workflow?.approveStatusEn === "Pending";

      const shouldShowGrayStatus = isPending && hasRejectedStatus;

      return (
        <>
          <label>{`${t('leave_type.label.sequence')} ${index + 1}`}</label>
          <Card size="small" key={index} style={{ border: "1px solid #000" }}>
            <Row>
              <Col span={16}>
                <label style={{ color: "#667085" }}>{`${t('leave_type.label.approver')}`}</label>
              </Col>
              <Col span={8}>
                <span style={{ color: "#667085", display: "flex", justifyContent: "flex-end" }}>{t("leave_type.label.approvalDate")}</span>
              </Col>
              <Col span={16}>
                <span>{i18n.language === "en" ? workflow?.employee?.nameAndSurnameEn : workflow?.employee?.nameAndSurname}</span>
              </Col>
              <Col span={8}>
                <span style={{ display: "flex", justifyContent: "flex-end" }}>{workflow?.date ? formatDateTime(workflow?.date) : "-"}</span>
              </Col>
              <Col span={16} style={{ marginTop: '10px' }}>
                <span>{i18n.language === "en" ? workflow?.employee?.position?.positionNameEn : workflow?.employee?.position?.positionName}</span>
              </Col>
              <Col span={8} style={{ marginTop: '10px' }}>
                <label style={{ display: "flex", justifyContent: "flex-end" }}>
                  {shouldShowGrayStatus ?
                    <Badge color="#667085" text={workflow?.["approveStatus" + language]} style={{ backgroundColor: "#EAEBEC", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} /> :
                    <StatusTag value={(workflow?.["approveStatus" + language])} />
                  }
                </label>
              </Col>
            </Row>
          </Card>
        </>
      );
    });
  }

  useEffect(() => {
    if (initialValues?.attachFile && initialValues?.attachFile[0]) {
      const fileUrls = [];
      const fileNames = [];
      const fileSizes = [];
      const fileTypes = [];
      const fileList = []


      for (let index = 0; index < initialValues?.attachFile?.length; index++) {
        const fileByte = initialValues?.attachFile[index]?.fileByte;
        const fileType = initialValues?.attachFile[index]?.fileType;
        const fileName = initialValues?.attachFile[index]?.fileName;

        if (typeof fileByte === "string") {
          const blob = new Blob([Uint8Array.from(atob(fileByte), c => c.charCodeAt(0))], {
            type: fileType,
          });
          const fileUrl = URL.createObjectURL(blob);
          const fileSizeInMB = (blob.size / (1024 * 1024)).toFixed(2);

          // เพิ่มค่าลงใน array
          fileTypes.push(fileType);
          fileUrls.push(fileUrl);
          fileNames.push(fileName);
          fileSizes.push(fileSizeInMB);
        }

        const dataURL = `data:${fileType};base64,${fileByte}`;
        const file = dataURLtoFile(dataURL, fileName);
        fileList.push(file)

      }

      // Set state หลังจากวนลูปเสร็จ
      setFileType?.(fileTypes)
      setImageUrl(fileUrls);
      seeFileName(fileNames)
      setInitialValuesFileName(fileNames)
      setInitialValuesImageUrl(fileUrls)
      setInitialValuesFileList(fileList)
      setInitialValuesFileType(fileTypes)
      setfileSizeInMB(fileSizes);
    } else {
      setImageUrl(null);
    }

    getWorkflow();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCompany, currentEmployee, initialValues, modalType]);

  function base64ToFile(base64String, fileName, mimeType = 'application/octet-stream') {
    const byteCharacters = atob(base64String);
    const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: mimeType });
    return new File([blob], fileName, { type: mimeType });
  }

  const getWorkflow = useCallback(async () => {
    let data = [];
    if (modalType === MODAL_TYPE.VIEW) {
      data = await services.getWorkflowByRequestId({
        requestId: generateRandomString(),
        companyId: currentCompany,
        employeeId: currentEmployee,
        flowRequestId: initialValues.endorseTimeRequestId,
      });
      setCurrentWorkflow(data?.data?.approvalSequence)
    }
  }, [currentCompany, currentEmployee, initialValues.endorseTimeRequestId, modalType])

  const handleMenuChange = useCallback(
    (e) => {
      setMenu(e);
    }, [setMenu]);


  function getItem(label, key,) {
    return {
      label: label,
      key: key,
    };
  }

  const MODAL_TYPE = {
    CREATE: "create",
    EDIT: "edit",
    VIEW: "view",
  };

  const MENU = [
    getItem(t("leave_type.label.detail"), MY_REQUEST_TYPE.DETAIL),
    (modalType === MODAL_TYPE.VIEW && initialValues?.approveStatusEn !== 'Draft') ? getItem(t("leave_type.label.approvalSequence"), MY_REQUEST_TYPE.APPROVALSEQ) : null,
    (modalType === MODAL_TYPE.VIEW && (initialValues?.timelineReject?.length > 0)) ? getItem(t("leave_type.label.approvalReqSequence"), MY_REQUEST_TYPE.APPROVALREJECTSEQ) : null,
  ];


  const EndorseTimeSchema = Yup.object().shape({
    endorseMentDate: Yup.string().required("Please select."),
    description: Yup.string().required("Please enter."),
  });

  const EndorseTimeSchemaReject = Yup.object().shape({
    // endorseMentDate: Yup.string().required("Please select."),
    // description: Yup.string().required("Please enter."),
    descriptionReject: Yup.string().required("Please enter."),
  });

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...INITIAL_VALUES,
        ...initialValues,
        endorseMentDate: initialValues?.endorseMentDate ? dayjs(initialValues?.endorseMentDate) : null,
        createDate: initialValues?.createDate ? dayjs(initialValues?.createDate) : null
      }}
      onSubmit={initialValues.reject == 'reject' ? onReject : onSubmit}
      validationSchema={initialValues.reject == 'reject' ? EndorseTimeSchemaReject : EndorseTimeSchema}
    >
      {({ values = {}, resetForm = () => { }, setFieldValue }) => {

        let language = i18n.language === 'en' ? "En" : ""
        return (
          <Form className={className}>
            {/* <Divider /> */}
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
              <Flex gap={10} vertical={true} >
                <ConfigProvider
                  theme={{
                    components: {
                      Tabs: {
                        itemHoverColor: "var(--tab-color)",
                        itemActiveColor: "var(--tab-color)"
                      },
                    },
                  }}
                >
                  <Tabs items={MENU} onChange={(e) => { handleMenuChange(e); setCurrentMenu(e); }} />
                </ConfigProvider>

                {(selectedMenu === MY_REQUEST_TYPE.DETAIL && (modalType === MODAL_TYPE.CREATE || modalType === MODAL_TYPE.EDIT)) && (
                  <>
                    <Row gutter={[0, 12]}>
                      <Col span={24}>
                        <DatePicker
                          disabled={modalType == 'view'}
                          name="endorseMentDate"
                          label={t('my_request.label.endorsement-date')}
                          placeholder={t('common.placeholder.ddmmyyyy')}
                          size="large"
                          format={formatDate()}
                          required />
                      </Col>
                      <Col span={12} style={{ paddingRight: "8px" }}>
                        <TimePicker
                          disabled={modalType == 'view'}
                          name="startTime"
                          label={t('leave_type.label.start-time')}
                          suffeicon={false}
                          format="HH:mm:ss"
                          size="large" />
                      </Col>
                      <Col span={12} style={{ paddingLeft: "8px" }}>
                        <TimePicker
                          disabled={modalType == 'view'}
                          name="endTime"
                          label={t('leave_type.label.end-time')}
                          suffeicon={false}
                          format="HH:mm:ss"
                          size="large" />
                      </Col>
                    </Row>
                    <div>
                      <>
                        <><Dragger
                          disabled={modalType === 'view'}
                          name="attachFile"
                          multiple={false}
                          showUploadList={false}
                          onRemove={(e) => {
                            onDeleteFile();
                          }}
                          onChange={(e) => {
                            if (e.event) {
                              onAttachFileChange({
                                attachFile: e,
                                setFieldValue,
                                setImageUrl,
                                seeFileName,
                                initialValuesImageUrl,
                                initialValuesFileName,
                                initialValuesFileType,
                                initialValuesFileList,
                                setInitialValuesFileName,
                                setInitialValuesFileType,
                                setInitialValuesImageUrl,
                                setInitialValuesFileList,
                                setFileType
                              });
                            }
                          }}
                          style={{
                            border: "1px solid #EAECF0",
                            borderRadius: "10px",
                            background: "#FAFAFA",
                            padding: "20px",
                          }}
                        >
                          <p className="ant-upload-drag-icon">
                            <CloudUploadOutlined style={{ fontSize: "32px", color: "#888" }} />
                          </p>
                          <p
                            className="ant-upload-text"
                            style={{ fontSize: "16px", fontWeight: "500", color: "#4A4A4A" }}
                          >
                            {t("description.Select the desired file or drag and drop")}
                          </p>
                        </Dragger>
                        </>
                        <p>{t('description.Supported files mb')}</p></></div>
                    {imageUrl && (
                      <>
                        {imageUrl?.map((attachFile, index) => (
                          <>
                            {index === 0 && (
                              <Col span={24}>
                                <label className={cx("label", styles.label)}>
                                  {t('employee.label.attachment-file')}
                                </label>
                              </Col>
                            )}

                            <Row>
                              <div
                                style={{
                                  border: "2px solid var(--button-color)",
                                  borderRadius: "10px",
                                  padding: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  width: "100%",
                                  maxWidth: "500px",
                                  boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                                  marginTop: "10px"
                                }}
                              >
                                <a
                                  href={attachFile}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    textDecoration: "none",
                                  }}
                                >
                                  <img
                                    src={attachFile}
                                    alt="uploaded"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.style.display = "none";
                                      const fallbackElement = e.target.nextElementSibling;
                                      if (fallbackElement) fallbackElement.style.display = "block";
                                    }}
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      objectFit: "cover",
                                      borderRadius: "5px",
                                      marginRight: "10px",
                                    }}
                                  />
                                  <div style={{ flex: 1 }}>
                                    <div style={{ fontWeight: "bold", color: "#333", width: "350px" }}>{fileName[index]}</div>
                                    <div style={{ fontSize: "12px", color: "#888" }}>{fileSizeInMB[index]} MB</div>
                                  </div>
                                </a>
                                <Button
                                  type="default"
                                  style={{
                                    background: "none",
                                    border: "none",
                                    color: "#888",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                  onClick={() => {
                                    const newImage = imageUrl.filter((_, i) => i !== index);
                                    const newfileName = fileName.filter((_, i) => i !== index);
                                    const newfileSize = fileSizeInMB.filter((_, i) => i !== index);
                                    const newfileType = fileType.filter((_, i) => i !== index);

                                    setImageUrl(newImage);
                                    seeFileName(newfileName);
                                    setfileSizeInMB(newfileSize)
                                    setInitialValuesFileName(newfileName)
                                    setInitialValuesImageUrl(newImage)
                                    setInitialValuesFileType(newfileType)
                                    setInitialValuesFileList(values.attachFile.filter((_, i) => i !== index))
                                    setFieldValue("attachFile", values.attachFile.filter((_, i) => i !== index));
                                    setFieldValue("attachFileType", values.attachFileType.filter((_, i) => i !== index));
                                    setFieldValue("attachFileName", values.attachFileName.filter((_, i) => i !== index));
                                  }}
                                >
                                  &#x2715;
                                </Button>
                              </div >
                            </Row >
                          </>
                        ))}
                      </>
                    )
                    }

                    <Row>
                      <Col span={24} style={{ marginTop: "40px" }}>
                        <Input
                          disabled={modalType == 'view'}
                          name="description"
                          label={t('expense.lable.reason')}
                          placeholder={t('expense.lable.pls_fill_reason')}
                          size="large"
                          required
                        />
                      </Col>
                    </Row>
                  </>
                )}

                {(selectedMenu === MY_REQUEST_TYPE.DETAIL && modalType === MODAL_TYPE.VIEW) && (
                  <>
                    <Row>
                      <Col span={11}>
                        <DatePicker
                          disabled={true}
                          name="createDate"
                          label={t('my_request.label.create-date')}
                          placeholder={t('common.placeholder.ddmmyyyy')}
                          size="large"
                          format={formatDate()}
                          required
                        />
                      </Col>
                      <Col span={11} offset={2}>
                        <DatePicker
                          disabled={true}
                          name="endorseMentDate"
                          label={t('my_request.label.endorsement-date')}
                          placeholder={t('common.placeholder.ddmmyyyy')}
                          size="large"
                          format={formatDate()}
                          required
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={11}>
                        <Input
                          disabled={true}
                          name="sameTime"
                          label={t('my_request.label.sameTime')}
                          placeholder={t('my_request.label.sameTime')}
                          size="large"
                          required
                        />
                      </Col>
                      <Col span={11} offset={2}>
                        <label className={cx("label", styles.label)}>
                          {t('my_request.label.workStatus')}
                        </label>
                        <Col span={24} style={{ marginTop: "10px" }}>
                          <WorkinStatus value={(values?.["workStatus"])} />
                        </Col>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <label className={cx("label", styles.label)} style={{ fontSize: "16px" }}>
                          {t('leave_type.label.timeForRequestingCertification')}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={11} >
                        <TimePicker
                          disabled={true}
                          name="startTime"
                          label={t('leave_type.label.start-time')}
                          suffeicon={false}
                          format="HH:mm:ss"
                          size="large"
                        />
                      </Col>
                      <Col span={11} offset={2}>
                        <TimePicker
                          disabled={true}
                          name="endTime"
                          label={t('leave_type.label.end-time')}
                          suffeicon={false}
                          format="HH:mm:ss"
                          size="large"
                        />
                      </Col>
                    </Row>
                    <Row>
                      {!imageUrl ? (
                        <>
                          <Col span={24} >
                            <label className={cx("label", styles.label)}>
                              {t('employee.label.attachment-file')}
                            </label>

                            <Dragger
                              disabled={true}
                              name="attachFile"
                              multiple={false}
                              onRemove={() => {
                                onDeleteFile();
                              }}
                              onChange={(e) => {
                                onAttachFileChange({
                                  attachFile: e,
                                  setFieldValue,
                                  setImageUrl,
                                  seeFileName,
                                });
                              }}
                              style={{
                                border: "1px solid #EAECF0",
                                borderRadius: "10px",
                                background: "#FAFAFA",
                                padding: "20px",
                              }}
                            >
                              <p className="ant-upload-drag-icon">
                                <CloudUploadOutlined style={{ fontSize: "32px", color: "#888" }} />
                              </p>
                              <p
                                className="ant-upload-text"
                                style={{ fontSize: "16px", fontWeight: "500", color: "#4A4A4A" }}
                              >
                                {t("description.Select the desired file or drag and drop")}
                              </p>
                            </Dragger>
                          </Col>
                          <p>{t('description.Supported files mb')}</p></>
                      ) :
                        imageUrl ? (
                          <>
                            {imageUrl?.map((attachFile, index) => (
                              <>
                                {index === 0 && (
                                  <Col span={24}>
                                    <label className={cx("label", styles.label)}>
                                      {t('employee.label.attachment-file')}
                                    </label>
                                  </Col>
                                )}
                                <div
                                  style={{
                                    border: "2px solid var(--button-color)",
                                    borderRadius: "10px",
                                    padding: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    maxWidth: "500px",
                                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                                    marginTop: "10px"
                                  }}
                                >
                                  <a
                                    href={attachFile}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      textDecoration: "none",
                                    }}
                                  >
                                    <img
                                      src={attachFile}
                                      alt="uploaded"
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.style.display = "none";
                                        const fallbackElement = e.target.nextElementSibling;
                                        if (fallbackElement) fallbackElement.style.display = "block";
                                      }}
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        objectFit: "cover",
                                        borderRadius: "5px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    <div style={{ flex: 1 }}>
                                      <div style={{ fontWeight: "bold", color: "#333", width: "350px" }}>{fileName[index]}</div>
                                      <div style={{ fontSize: "12px", color: "#888" }}>{fileSizeInMB[index]} MB</div>
                                    </div>
                                  </a>
                                </div>
                              </>
                            ))}
                          </>
                        ) : null
                      }
                    </Row>
                    <Row>
                      <Col span={11}>
                        <Input
                          disabled={true}
                          name="description"
                          label={t('leave_type.label.note')}
                          placeholder={t('expense.lable.pls_fill_reason')}
                          size="large"
                          required
                          type=""
                          rows="1"
                        />
                      </Col>
                      <Col span={11} offset={2}>
                        <label className={cx("label", styles.label)}>
                          {t('leave_type.label.leave_status')}
                        </label>
                        <Col span={24} style={{ marginTop: "10px" }}>
                          <StatusTag value={(values?.["approveStatus" + language])} />
                        </Col>
                      </Col>
                    </Row>
                    {((initialValues.reject == 'reject') || (Array.isArray(initialValues.timelineReject) && initialValues?.timelineReject?.length > 0)) &&
                      <Row>
                        <Col span={24}>
                          <Input
                            disabled={initialValues.reject != 'reject'}
                            type=""
                            name="descriptionReject"
                            label={t('leave_type.label.noteReject')}
                            placeholder={t('leave_type.label.noteReject')}
                            size="large"
                            autoComplete="off"
                            required
                          />
                        </Col>
                      </Row>
                    }

                    {approveType === REQUEST_APPROVE_TAB.ENDORSETIME && (
                      <Row justify="end">
                        <Space size={12} className={styles.filterbtn}>
                          <Button
                            type="default"
                            onClick={() => {
                              onReject()
                            }}
                            style={{
                              height: "40px", borderRadius: "8px",
                              padding: "8px 16px"
                            }}>
                            {t("action.reject")}
                          </Button>
                          <Button
                            type="primary"
                            onClick={() => {
                              onApprove()
                            }}
                            style={{
                              height: "40px", borderRadius: "8px",
                              backgroundColor: "var(--button-color)",
                              padding: "8px 16px"
                            }}>
                            {t("action.approve")}
                          </Button>
                        </Space>
                      </Row>
                    )}
                  </>
                )}

                {selectedMenu === MY_REQUEST_TYPE.APPROVALSEQ && (
                  <>
                    {Array.isArray(currentWorkflow) &&
                      currentWorkflow?.map((workflow, index) => (
                        <>
                          <label>{`${t('leave_type.label.sequence')} ${index + 1}`}</label>
                          <Card size="small" key={index} style={{ border: "1px solid #000" }}>
                            <Row>
                              <Col span={16}>
                                <label style={{ color: "#667085" }}>{`${t('leave_type.label.approver')}`}</label>
                              </Col>
                              <Col span={8}>
                                <span style={{ color: "#667085", display: "flex", justifyContent: "flex-end" }}>{t("leave_type.label.approvalDate")}</span>
                              </Col>
                              <Col span={16}>
                                <span>{workflow?.listEmployees?.slice(0, 3).join(" , ")}</span>
                                <> </>
                                {workflow?.listEmployees?.length > 3 ? (
                                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                  <a
                                    onClick={() => {
                                      setOpenListEmployee(true);
                                      setListEmployees(workflow?.listEmployees);
                                    }}
                                    style={{
                                      display: "inline-block",
                                      borderRadius: "36px",
                                      padding: "4px 12px",
                                      fontSize: "0.7vw",
                                      color: "#fff",
                                      background: "var(--primary-color)",
                                      textDecoration: "none",
                                      fontWeight: "bold",
                                      border: "1px solid var(--primary-color)",
                                      cursor: "pointer"
                                    }}

                                  >
                                    {`+ ${workflow?.listEmployees?.length - 3} ...`}
                                  </a>
                                ) : ""}
                              </Col>
                              <Col span={8}>
                                <span style={{ display: "flex", justifyContent: "flex-end" }}>{workflow?.approveDate ? formatDateTime(workflow?.approveDate) : "-"}</span>
                              </Col>
                            </Row>
                            <Row >
                              <Col span={16} style={{ marginTop: '10px' }}>
                                <label>
                                  {workflow?.workFlowtype}
                                </label></Col>
                              <Col span={8} style={{ marginTop: '10px' }} >
                                <label style={{ display: "flex", justifyContent: "flex-end" }}> <StatusTag value={(workflow?.["approveStatus" + language])} /> </label>
                              </Col>
                            </Row>
                          </Card >
                        </>
                      ))}
                  </>
                )}
                {selectedMenu === MY_REQUEST_TYPE.APPROVALREJECTSEQ && (
                  <>
                    {Array.isArray(initialValues.timelineReject) && initialValues?.timelineReject?.length > 0 &&
                      fnRejectFor(initialValues)
                    }
                  </>
                )}
              </Flex>

              {openListEmployee && (
                <Modal title={t("leave_type.label.approver")}
                  open={openListEmployee}
                  onCancel={() => setOpenListEmployee(false)}
                  footer={false}
                  width="510px"
                  maskClosable={false}
                >
                  <Card size="small" style={{ border: "1px solid #000" }}>
                    {listEmployees?.map((employee, index) => (
                      <label key={index}>
                        {employee}
                        <br />
                      </label>
                    ))}
                  </Card>
                </Modal>
              )}

              {standAlone == true &&
                <Flex justify="end">
                  <Space direction="horizontal" size={12}>
                    <Button
                      id="mst__cancelBtn"
                      type="default"
                      style={{ height: "40px", borderRadius: "8px" }}
                      onClick={() => {
                        resetForm();
                        onCancel();
                      }}
                    >
                      {t("common.cancel")}
                    </Button>

                    {(initialValues.reject == 'reject' && useCurrentMenu == MY_REQUEST_TYPE.DETAIL) &&
                      <Button
                        htmlType="submit"
                        onClick={() => {
                          setFieldValue("sendingType", "SUBMIT");
                        }}
                        type="primary"
                        style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" }}
                      >
                        {t("common.reject")}
                      </Button>
                    }

                    {modalType != 'view' ?
                      <><Button
                        id="mst__cancelBtn"
                        type="default"
                        htmlType="submit"
                        onClick={async () => {
                          setFieldValue("sendingType", "DRAFT");
                          setFieldValue("attachFile", initialValuesFileList);
                          setFieldValue("attachFileName", initialValuesFileName);
                          setFieldValue("attachFileType", initialValuesFileType);
                        }}
                        style={{ height: "40px", borderRadius: "8px" }}
                      >
                        {t("common.draft")}
                      </Button>
                        {modalType === MODAL_TYPE.EDIT && values.sendingType === 'DRAFT' ?
                          <Button
                            type="default"
                            style={{ height: "40px", borderRadius: "8px", color: "red", borderColor: "red" }}
                            onClick={() => {
                              resetForm();
                              onDelete(values);
                            }}
                          >
                            {t("common.delDraft")}
                          </Button>
                          : null}
                        <Button
                          // className='primary-submit'
                          htmlType="submit"
                          onClick={() => {
                            setFieldValue("sendingType", "SUBMIT");
                            setFieldValue("attachFile", initialValuesFileList);
                            setFieldValue("attachFileName", initialValuesFileName);
                            setFieldValue("attachFileType", initialValuesFileType);
                            // if (values?.attachFile && values?.attachFile[0]) {
                            //   const File = base64ToFile(values?.attachFile[0], values?.attachFileName[0], values?.attachFileType[0]);
                            //   setFieldValue("attachFile", File);
                            // }
                          }}
                          type="primary"
                          style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" }}
                        >
                          {t("my_timesheet.label.approve")}
                        </Button>
                      </>
                      : null}

                  </Space>
                </Flex>
              }
            </Space>
          </Form>
        );
      }}
    </Formik>
  );
}

export default EndorseTimeForm;
